import { ColorModeProvider, MuiProvider, LanguageProvider } from "@shared/context";

export const RootComponent = ({ children }) => {
	return (
		<LanguageProvider>
			<ColorModeProvider>
				<MuiProvider>{children}</MuiProvider>
			</ColorModeProvider>
		</LanguageProvider>
	);
};
